import { BaseDto } from '../base.dto';
import { AclStockPermissionDto } from '../acl-stock-permission';

export class AclStockPermissionListDto extends BaseDto {
  name: string;
  tags?: string;
  lastSharedDate?: Date;
  stockPermissions?: AclStockPermissionDto[];
}
